import React from 'react';

import { usePipelineTagsTableContext } from 'app/settings/tags-page/context/PipelineTagsTableContext';
import MODAL_OPTIONS from 'app/settings/tags-page/MODAL_OPTIONS';
import AddTagForm from './AddTagForm';
import EditTagForm from './EditTagForm';
import DeleteTagConfirm from './DeleteTagConfirm';

export default function PipelineTagModal() {
  const { isOpenModal, modalContentOption, selectedTag, onCloseModal } = usePipelineTagsTableContext();

  switch (modalContentOption) {
    case MODAL_OPTIONS.addTag:
      return <AddTagForm open={isOpenModal} onClose={onCloseModal} />;
    case MODAL_OPTIONS.editTag:
      return <EditTagForm open={isOpenModal} onClose={onCloseModal} tag={selectedTag} />;
    case MODAL_OPTIONS.deleteTag:
      return <DeleteTagConfirm open={isOpenModal} onClose={onCloseModal} tag={selectedTag} />;
    default:
      return null;
  }
}
